import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface SuggestedQuestionButtonProps {
  question: string;
  onClick: () => void;
  [key: string]: any;
}

export const SuggestedQuestionButton = ({
  question,
  onClick,
  className,
  ...rest
}: SuggestedQuestionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      "focus-visible:!outline-secondary transition-colors duration-200 focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2 disabled:cursor-not-allowed",
      "border-primary border",
      "text-secondary",
      "hover:bg-tertiary",
      "whitespace-normal",
      "rounded-[1.25rem]",
      "px-3.5 py-2",
      "text-left",
      "text-sm font-medium leading-5",
      "dark:text-dark",
      className,
    )}
    {...rest}
  >
    {question}
  </button>
);
